<template lang="pug">
  transition(name="fade")
    div.legend.legend--treads(:class="showMapLegend ? 'open' : 'close'")
      e-perfect-scrollbar
        div.head(@click="showMapLegend = !showMapLegend")
          h2.title {{$translate('Обозначения')}}
          span.legend__close(v-if="showMapLegend")
          span.legend__open(v-else)

        div.type-group.map-mapping-selector
          div.type.all
            label.checked
              span
              span.marker Отобразить все элементы карты
            label.new-check
              input.new-checkbox(type="checkbox" @change="$emit('showAll', showAll)" v-model="showAll")
              span
          div.type.all
            label.checked
              span
              span.marker Отобразить все потоки
            label.new-check
              input.new-checkbox(type="checkbox" @change="$emit('showAllThreads', showAllThreads)" v-model="showAllThreads")
              span
          div.type.all
            label.checked
              span
              span.marker Тарифы
            label.new-check
              input.new-checkbox(type="checkbox" @change="$emit('showModelTariffs', showModelTariffs)" v-model="showModelTariffs")
              span

        div.type-group.obj
          div.type
            label.checked
              span.marker {{$translate('Объекты обращения с отходами')}}

          div.group
            div.type.obj-utiliz
              label.checked
                span.marker {{$translate('Объекты обращения с отходами')}}

            div.type.obj-mps
              label.checked
                span.marker {{$translate('МПС (МПП)')}}
            div.type.obj-mmtzoo
              label.checked
                span.marker {{$translate('ММЦОО')}}

        div.type-group.loc
          div.type
            label.checked
              span.marker {{$translate('Населенные пункты')}}
          div.group
            div.type.loc-distrib
              label.checked
                span.marker {{$translate('Отходы распределены')}}
            div.type.loc-notdistrib
              label.checked
                span.marker {{$translate('Отходы не распределены')}}

        div.type-group.lines
          div.type
            label.checked
              input.checkbox(type="checkbox" @change="showAllChange" v-model="showAllLine")
              span
              span.marker {{$translate('Потоки')}}
            label.new-check
              input.new-checkbox(type="checkbox")
              span
          div.group
            div.type.lines-any
              label.checked
                input.checkbox(type="checkbox" @change="$emit('showTKOLine', showTKOLine)" v-model="showTKOLine")
                span
                span.marker
                  span(
                  :style="getLineStyle('fact', 'tko')"
                  ).line-color
                  | {{$translate('ТКО')}}
            div.type.lines-any
              label.checked
                input.checkbox(type="checkbox" @change="$emit('showOtherLine', showOtherLine)" v-model="showOtherLine")
                span
                span.marker
                  span(
                    :style="getLineStyle('fact', 'other')"
                  ).line-color
                  | {{$translate('Прочие отходы')}}
            div.type.lines-any
              label.checked
                input.checkbox(type="checkbox" @change="$emit('showMixedLine', showMixedLine)" v-model="showMixedLine")
                span
                span.marker
                  span(
                    :style="getLineStyle('fact', 'mixed')"
                  ).line-color
                  | {{$translate('Смешанный поток')}}
        div.type-group.load
          div.type
            label.checked
              span.marker {{$translate('Нагрузка объекта')}}
          div.group
            div.type.load-low
              label.checked
                span.marker {{$translate('Минимальная нагрузка')}}
            div.type.load-mid
              label.checked
                span.marker {{$translate('Средняя нагрузка')}}
            div.type.load-high
              label.checked
                span.marker {{$translate('Максимальная нагрузка')}}

        div.type-group.load
          div.type
            label.checked
              span.marker {{$translate('Статус')}}
            label.new-check
              input.new-checkbox(type="checkbox")
              span
          div.group
            div.type.status-active
              label.checked
                input.checkbox(type="checkbox" @change="$emit('showStatusActive', showStatusActive)" v-model="showStatusActive")
                span
                span.marker {{$translate('Действующий')}}
            div.type.status-planned
              label.checked
                input.checkbox(type="checkbox" @change="$emit('showStatusPlan', showStatusPlan)" v-model="showStatusPlan")
                span
                span.marker {{$translate('Планируемый')}}

</template>

<script>
  import {TREADS_POLY_STYLE, TREADS_POLY_SUBCOLOR} from "../../../config/map";

  export default {
    name: 'map-legend',
    data: () => {
      return {
        showAll: false,
        showAllThreads: false,
        showAllLine: true,
        showAllStatus: true,
        showStatusActive: true,
        showStatusPlan: true,
        showTKOLine: true,
        showOtherLine: true,
        showMixedLine: true,
        showModelTariffs: false,
      }
    },
    props: {
      showRemoved: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      showMapLegend: {
        get () {
          return this.$store.state.showMapLegend
        },
        set (value) {
          this.$store.commit('mapLegend', value)
        }
      }
    },
    methods: {
      showAllChange(){
        this.showTKOLine = this.showAllLine ;
        this.showOtherLine  = this.showAllLine;
        this.showMixedLine  = this.showAllLine;
        this.$emit('showTKOLine', this.showAllLine);
        this.$emit('showOtherLine', this.showAllLine);
        this.$emit('showMixedLine', this.showAllLine);
      },
      getLineStyle (type, subtype) {
        const style = {...TREADS_POLY_STYLE[type]}

        if (subtype && TREADS_POLY_SUBCOLOR[subtype]) {
          style.color = TREADS_POLY_SUBCOLOR[subtype]
        }

        if (style.dashArray) {
          return `background:repeating-linear-gradient(90deg, ${style.color}, ${style.color} 10px, transparent 10px, transparent 20px);`
        }

        return `background:${style.color};`
      }
    }
  }
</script>

<style>
  .legend.legend--treads .type-group .type.all{
    border-bottom: none;
    margin-left: -4px;
  }
  .legend.legend--treads .type-group .type.all-treads{
    border-top: none;
    margin-left: -4px;
  }
</style>
